import { render, staticRenderFns } from "./PersonalExpiredVouchers.vue?vue&type=template&id=f1c32c6a&scoped=true"
import script from "./PersonalExpiredVouchers.vue?vue&type=script&lang=js"
export * from "./PersonalExpiredVouchers.vue?vue&type=script&lang=js"
import style0 from "./PersonalExpiredVouchers.vue?vue&type=style&index=0&id=f1c32c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c32c6a",
  null
  
)

export default component.exports